<template>
	<loadList :loading="loading" @load="$emit('load')">
		<template v-if="!showJobV2">
			<job v-for="(item, index) in list" :key="index" :job="item" :apply-now="applyNow" :source="source" :width="width" :height="height" @applyed="applyed"></job>
		</template>

		<template v-else>
			<jobV2 v-for="(item, index) in list" :key="index" :job="item" :apply-now="applyNow" :source="source" :width="width" :height="height" @applyed="applyed"></jobV2>
		</template>
	</loadList>
</template>

<script>
import job from './job.vue'
import jobV2 from './jobV2.vue'
import loadList from './loadList.vue'
import flexible from 'flexible.js'

export default {
	components: { loadList, job, jobV2 },
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		list: {
			type: Array,
			default: () => {}
		},
		applyNow: {
			type: Boolean,
			default: false
		},
		source: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: 686
		},
		height: {
			type: [String, Number],
			default: 517
		}
	},
	data() {
		return {
			showJobV2: false
		}
	},
	mounted() {
		const showJobV2 = this.$route.query.showJobV2 === 'true' ? true : false
		this.showJobV2 = showJobV2
		flexible(750)
	},
	methods: {
		applyed(data) {
			this.$emit('applyed', data)
		}
	}
}
</script>
